import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/RadioRelay/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/RadioRelay/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/RadioRelay/GetById`, payload),
    Add: (payload) => Repository.post(`/api/RadioRelay/Add`, payload),
    Edit: (payload) => Repository.post(`/api/RadioRelay/Edit`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/RadioRelay/ChangeStatus`, payload),
    Delete: (payload) => Repository.post(`/api/RadioRelay/Delete`, payload),
}
